import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiCheckCircle, FiInfo, FiAlertCircle, FiX } from 'react-icons/fi';
import { useSolution } from '../../context/SolutionContext';

const Toast = () => {
  const { state, dispatch } = useSolution();
  const toast = state.uiState.toast;
  
  useEffect(() => {
    if (toast) {
      const timer = setTimeout(() => {
        dispatch({ type: 'CLEAR_TOAST' });
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [toast, dispatch]);
  
  const toastConfig = {
    success: { icon: FiCheckCircle, color: 'text-green-500', bg: 'bg-green-50', border: 'border-green-200' },
    info: { icon: FiInfo, color: 'text-blue-500', bg: 'bg-blue-50', border: 'border-blue-200' },
    error: { icon: FiAlertCircle, color: 'text-red-500', bg: 'bg-red-50', border: 'border-red-200' }
  };
  
  return (
    <AnimatePresence>
      {toast && (
        <motion.div
          initial={{ opacity: 0, y: 20, scale: 0.9 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.9 }}
          className="fixed bottom-6 right-6 z-50"
        >
          <div className={`flex items-center gap-3 p-4 rounded-xl shadow-lg border ${toastConfig[toast.type].bg} ${toastConfig[toast.type].border}`}>
            {React.createElement(toastConfig[toast.type].icon, { className: `w-5 h-5 ${toastConfig[toast.type].color}` })}
            <p className="text-sm font-medium text-gray-900">{toast.message}</p>
            <button
              onClick={() => dispatch({ type: 'CLEAR_TOAST' })}
              className="ml-4 text-gray-400 hover:text-gray-600"
            >
              <FiX className="w-4 h-4" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Toast;